// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import validateRequiredDropdown from "@store/Framework/Common/Utilities/validateRequiredDropdown";
import { BaseFormFieldProps, FormFieldValue } from "@store/Framework/Types/FormField";
import SearchShipToField, {
    SearchShipToFieldPresentationProps,
    SearchShipToFieldProps,
} from "@store/Library/Components/SearchShipToField";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { FC, useEffect, useState } from "react";

export const shipToFormFieldLabelKey = "Ship To";

type FieldValueType = string;
export type ShipToFormFieldValue = FormFieldValue<FieldValueType>;

export interface ShipToFormFieldPresentationProps extends ExpandStyles<ShipToFormFieldStyles> {}

export interface ShipToFormFieldProps
    extends Omit<SearchShipToFieldProps, keyof SearchShipToFieldPresentationProps | "error" | "selected">,
        ShipToFormFieldPresentationProps,
        BaseFormFieldProps<FieldValueType> {
    prefill?: boolean;
}

export interface ShipToFormFieldStyles {
    searchShipToField?: SearchShipToFieldPresentationProps;
}

export const shipToFormFieldStyles: ShipToFormFieldStyles = {};

const ShipToFormField: FC<ShipToFormFieldProps> = ({
    defaultValue = "",
    extendedStyles,
    label,
    onSelectionChange,
    onUpdate,
    onValidate,
    overridedStyles,
    prefill,
    required,
    showError = true,
    ...searchShipToFieldProps
}) => {
    const styles = useExpandProps(shipToFormFieldStyles, extendedStyles, overridedStyles);
    const [value, setValue] = useState(defaultValue);
    const [error, setError] = useState("");
    const currentShipTo = useAppSelector(getCurrentShipToState)?.value;
    const textLabel = typeof label === "string" ? label : translate(`${shipToFormFieldLabelKey}`);

    const validate = (value: string) => {
        let errorMessage: string | undefined;

        if (required) {
            errorMessage = validateRequiredDropdown(value, textLabel);
        }

        errorMessage = onValidate?.({ isValid: !errorMessage, value }) ?? errorMessage;

        setError(errorMessage || "");

        return !errorMessage;
    };

    useEffect(() => {
        let initialValue = value;

        if (prefill) {
            initialValue = value || currentShipTo?.customerSequence || "";

            if (initialValue !== value) {
                setValue(initialValue);
            }
        }

        const isValid = validate(initialValue);
        onUpdate?.({ isValid, value: initialValue });
    }, [currentShipTo?.customerSequence]);

    return (
        <SearchShipToField
            {...styles.searchShipToField}
            additionalParameters={{ exclude: ["createNew", "showAll"] }}
            placeholder={translate("Search or Select Ship To")}
            {...searchShipToFieldProps}
            error={showError ? error : ""}
            label={label || textLabel}
            onSelectionChange={customerSequence => {
                onSelectionChange?.(customerSequence);
                const value = customerSequence || "";
                setValue(value);
                const isValid = validate(value);
                onUpdate?.({ isValid, value });
            }}
            required={required}
            selected={value}
        />
    );
};

export default ShipToFormField;
